module.exports = __webpack_public_path__ + "static/img/banner_recruit_03.8237660.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/resource/images/join/banner_recruit_03.png
// module id = sWVz
// module chunks = 10